<template>
  <div
    class="popover bs-popover-auto fade show"
    :style="{
      width: tooltipWidth ? tooltipWidth + 'px' : undefined,
      minWidth: tooltipMinWidth ? tooltipMinWidth + 'px' : undefined,
      maxWidth: tooltipMaxWidth + 'px',
      '--bs-popover-max-width': tooltipMaxWidth + 'px'
    }"
  >
    <div class="popover-body">
      <template v-if="commissions">
        <table class="table table-flush-spacing">
          <tbody>
          <tr v-for="(commission, index) in commissions.percents" :key="index">
            <td>
              {{ commission.name }} {{ formatNumber(commission.percent, 1) }}%
              <span v-if="commission.note" class="commission-note">
                <i
                  class="ti ti-info-circle ti-sm ms-1 commission-note-icon"
                ></i>
                <span class="commission-note-tooltip">{{ commission.note }}</span>
              </span>
            </td>
            <td class="align-right" style="white-space: nowrap">{{ formatNumber(commission.amount) }} {{ currency }}</td>
          </tr>
          <tr v-for="(commission, index) in commissions.percents_with_limit" :key="index">
            <td>
              {{ commission.name }} {{ formatNumber(commission.percent, 1) }}%
              <span v-if="commission.note" class="commission-note">
                <i
                  class="ti ti-info-circle ti-sm ms-1 commission-note-icon"
                ></i>
                <span class="commission-note-tooltip">{{ commission.note }}</span>
              </span>
            </td>
            <td class="align-right" style="white-space: nowrap">{{ formatNumber(commission.amount) }} {{ currency }}</td>
          </tr>
          <tr v-for="(commission, index) in commissions.tiered_percents || []" :key="'tiered_percent_' + index">
            <td>
              {{ commission.name }} {{ formatNumber(commission.percent, 1) }}%
              <span v-if="commission.note" class="commission-note">
                <i
                  class="ti ti-info-circle ti-sm ms-1 commission-note-icon"
                ></i>
                <span class="commission-note-tooltip">{{ commission.note }}</span>
              </span>
            </td>
            <td class="align-right" style="white-space: nowrap">{{ formatNumber(commission.amount) }} {{ currency }}</td>
          </tr>
          <tr v-for="(commission, index) in commissions.fixed" :key="index">
            <td>
              {{ commission.name }}
              <span v-if="commission.note" class="commission-note">
                <i
                  class="ti ti-info-circle ti-sm ms-1 commission-note-icon"
                ></i>
                <span class="commission-note-tooltip">{{ commission.note }}</span>
              </span>
            </td>
            <td class="align-right" style="white-space: nowrap">{{ formatNumber(commission.amount) }} {{ currency }}</td>
          </tr>
          <tr v-for="(commission, index) in commissions.tiered_fixed || []" :key="'tiered_fixed_' + index">
            <td>
              {{ commission.name }}
              <span v-if="commission.note" class="commission-note">
                <i
                  class="ti ti-info-circle ti-sm ms-1 commission-note-icon"
                ></i>
                <span class="commission-note-tooltip">{{ commission.note }}</span>
              </span>
            </td>
            <td class="align-right" style="white-space: nowrap">{{ formatNumber(commission.amount) }} {{ currency }}</td>
          </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommissionTooltip',
  props: {
    commissionsData: {
      type: [Object, String],
      default: null
    },
    tooltipWidth: {
      type: Number,
      default: null
    },
    tooltipMinWidth: {
      type: Number,
      default: null
    },
    tooltipMaxWidth: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      commissions: {
        percents: [],
        fixed: [],
        percents_with_limit: [],
        tiered_percents: [],
        tiered_fixed: []
      },
      currency: 'Р'
    }
  },
  methods: {
    hideTooltipCallback() {
      if (this.params.hideTooltipCallback) {
        this.params.hideTooltipCallback();
      }
    },
    formatNumber(value, to_fixed = 0) {
      if (!value) return '0';
      value = value.toFixed(to_fixed)
      return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    },
  },
  beforeMount() {
    if (this.commissionsData) {
      if (typeof this.commissionsData === 'string') {
        try {
          this.commissions = JSON.parse(this.commissionsData)
        } catch (e) {
          this.commissions = {
            percents: [],
            fixed: [],
            percents_with_limit: [],
            tiered_percents: [],
            tiered_fixed: []
          }
        }
      } else {
        this.commissions = this.commissionsData
      }
      return
    }

    if (!this.params || !this.params.value) {
      return
    }

    const cell = this.params.value
    const store_id = cell.colDef.context.store_id
    this.commissions = cell.data[store_id].profit_info['commission']
  },
}
</script>

<style>
.popover {
  max-width: 400px;
  --bs-popover-max-width: 400px;
}

.align-right {
  text-align: right;
}

.commission-note-icon {
  color: #007bff;
}

.commission-note {
  display: inline-flex;
  position: relative;
  vertical-align: middle;
}

.commission-note-tooltip {
  display: none;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translate(8px, -50%);
  z-index: 3000;
  min-width: 180px;
  max-width: 320px;
  padding: 6px 8px;
  border-radius: 6px;
  color: #fff;
  background: rgba(33, 37, 41, 0.95);
  font-size: 12px;
  line-height: 1.3;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.commission-note:hover .commission-note-tooltip {
  display: block;
}
</style>